(function () {
  if (customElements.get('countdown-announcement-bar')) return;

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function getZonedParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    });
    var map = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      minute: parseInt(map.minute, 10),
      second: parseInt(map.second, 10),
    };
  }

  function getTimeZoneOffsetMs(date, timeZone) {
    var parts = getZonedParts(date, timeZone);
    var asUTC = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return asUTC - date.getTime();
  }

  function zonedWallTimeToUtc(year, month, day, hour, minute, second, timeZone) {
    var utc = Date.UTC(year, month - 1, day, hour, minute, second);
    var offset = getTimeZoneOffsetMs(new Date(utc), timeZone);
    utc -= offset;
    var offset2 = getTimeZoneOffsetMs(new Date(utc), timeZone);
    utc -= offset2 - offset;
    return utc;
  }

  function addCalendarDays(year, month, day, days) {
    var dt = new Date(Date.UTC(year, month - 1, day + days));
    return {
      year: dt.getUTCFullYear(),
      month: dt.getUTCMonth() + 1,
      day: dt.getUTCDate(),
    };
  }

  class CountdownAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      window.clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.hoursElement = this.querySelector('[data-countdown-hours]');
      this.minutesElement = this.querySelector('[data-countdown-minutes]');
      this.secondsElement = this.querySelector('[data-countdown-seconds]');
      this.timeZone = this.getAttribute('data-time-zone') || 'America/New_York';
      this.dailyReset = this.getAttribute('data-daily-reset') === 'true';
      this.resolveTargetTime();
      this.startTimer();
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
      if (!document.hidden) this.update();
    }

    getNextMidnight() {
      var parts = getZonedParts(new Date(), this.timeZone);
      var next = addCalendarDays(parts.year, parts.month, parts.day, 1);
      return zonedWallTimeToUtc(next.year, next.month, next.day, 0, 0, 0, this.timeZone);
    }

    getDeadline() {
      var date = (this.getAttribute('data-deadline-date') || '').trim();
      var time = (this.getAttribute('data-deadline-time') || '23:59:59').trim();
      var match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return NaN;
      var bits = time.split(':');
      var hour = parseInt(bits[0], 10);
      var minute = parseInt(bits[1], 10);
      var second = parseInt(bits[2], 10);
      if (isNaN(hour)) hour = 23;
      if (isNaN(minute)) minute = 59;
      if (isNaN(second)) second = 59;
      return zonedWallTimeToUtc(
        parseInt(match[1], 10),
        parseInt(match[2], 10),
        parseInt(match[3], 10),
        hour,
        minute,
        second,
        this.timeZone
      );
    }

    resolveTargetTime() {
      this.targetTime = this.dailyReset ? this.getNextMidnight() : this.getDeadline();
    }

    startTimer() {
      this.update();
      window.clearInterval(this.interval);
      this.interval = window.setInterval(this.update, 1000);
    }

    renderZero() {
      if (!this.hoursElement || !this.minutesElement || !this.secondsElement) return;
      this.hoursElement.textContent = '00';
      this.minutesElement.textContent = '00';
      this.secondsElement.textContent = '00';
    }

    update() {
      if (!this.hoursElement || !this.minutesElement || !this.secondsElement) return;

      if (!this.targetTime || isNaN(this.targetTime)) {
        this.renderZero();
        return;
      }

      var distance = this.targetTime - Date.now();

      if (distance <= 0) {
        if (this.dailyReset) {
          this.targetTime = this.getNextMidnight();
          distance = this.targetTime - Date.now();
        } else {
          this.renderZero();
          window.clearInterval(this.interval);
          return;
        }
      }

      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.hoursElement.textContent = pad(Math.min(hours, 99));
      this.minutesElement.textContent = pad(minutes);
      this.secondsElement.textContent = pad(seconds);
    }
  }

  customElements.define('countdown-announcement-bar', CountdownAnnouncementBar);
})();
